/* LUNVO — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';

  if (window.__mtLoaded) return;
  window.__mtLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initHeroParallax() {
    var img = document.querySelector('[data-mt-parallax]');
    if (!img || reduce) return;
    var ticking = false;
    function update() {
      var rect = img.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.05;
      img.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- FAQ acordeón ---------- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq-item__q');
      var a = item.querySelector('.mt-faq-item__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('mt-open');
        item.classList.toggle('mt-open');
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Galería del producto ---------- */
  function initGallery() {
    var gal = document.querySelector('[data-mt-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-mt-gallery-main]');
    var thumbs = gal.querySelectorAll('[data-mt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('mt-active'); });
        t.classList.add('mt-active');
      });
    });
  }

  /* Muestra solo las fotos del color elegido y pone la primera como principal */
  function filterGalleryByColor(color) {
    var gal = document.querySelector('[data-mt-gallery]');
    if (!gal || !color) return;
    var main = gal.querySelector('[data-mt-gallery-main]');
    var thumbs = gal.querySelectorAll('[data-mt-thumb]');
    if (!thumbs.length) return;
    color = color.toLowerCase();
    var first = null;
    var anyTagged = false;
    thumbs.forEach(function (t) {
      var c = (t.getAttribute('data-mt-color') || '').toLowerCase();
      if (!c) return;
      anyTagged = true;
      if (c === color) {
        t.style.display = '';
        if (!first) first = t;
      } else {
        t.style.display = 'none';
        t.classList.remove('mt-active');
      }
    });
    if (!anyTagged) return;
    if (first) {
      thumbs.forEach(function (x) { x.classList.remove('mt-active'); });
      first.classList.add('mt-active');
      var src = first.getAttribute('data-src');
      if (src && main) main.src = src;
    }
  }

  /* ---------- Variantes del producto ---------- */
  function initVariants() {
    var form = document.querySelector('[data-mt-variants]');
    if (!form) return;
    var dataEl = document.getElementById('mt-variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-mt-variant-id]');
    var priceNow = form.querySelector('[data-mt-price-now]');
    var priceOld = form.querySelector('[data-mt-price-old]');
    var addBtn = form.querySelector('[data-mt-add]');
    var addLabel = addBtn ? addBtn.querySelector('span') : null;
    var soldText = form.getAttribute('data-sold-text') || 'Agotado';
    var addText = form.getAttribute('data-add-text') || 'Añadir al carrito';
    var chosen = {};

    function money(cents) {
      var v = (cents / 100);
      return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function match() {
      var picks = Object.keys(chosen).map(function (k) { return chosen[k]; });
      return variants.find(function (v) {
        return v.options.length === picks.length && v.options.every(function (o, i) { return o === picks[i]; });
      });
    }

    var hasPacks = !!document.querySelector('[data-mt-pack]');
    function apply() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (!hasPacks) {
        if (priceNow) priceNow.textContent = money(v.price);
        if (priceOld) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceOld.textContent = money(v.compare_at_price);
            priceOld.style.display = '';
          } else { priceOld.style.display = 'none'; }
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? addText : soldText;
      }
    }

    var initialColor = null;
    var groups = form.querySelectorAll('[data-mt-option-index]');
    groups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-mt-option-index'), 10);
      var isColor = group.hasAttribute('data-mt-color-option');
      var vals = group.querySelectorAll('.mt-pdp__opt-val');
      var active = group.querySelector('.mt-pdp__opt-val.mt-active');
      if (active) {
        chosen[idx] = active.getAttribute('data-value');
        if (isColor) initialColor = active.getAttribute('data-value');
      }
      vals.forEach(function (val) {
        val.addEventListener('click', function () {
          vals.forEach(function (x) { x.classList.remove('mt-active'); });
          val.classList.add('mt-active');
          chosen[idx] = val.getAttribute('data-value');
          if (isColor) filterGalleryByColor(val.getAttribute('data-value'));
          apply();
        });
      });
    });
    apply();
    if (initialColor) filterGalleryByColor(initialColor);
  }

  /* ---------- Selector de packs + colores por unidad ---------- */
  function initPacks() {
    var wrap = document.querySelector('[data-mt-packs]');
    var form = document.querySelector('[data-mt-variants]');
    if (!wrap || !form) return;
    var packs = wrap.querySelectorAll('[data-mt-pack]');
    if (!packs.length) return;

    var qtyInput = form.querySelector('[data-mt-qty]');
    var idInput = form.querySelector('[data-mt-variant-id]');
    var addBtn = form.querySelector('[data-mt-add]');
    var color2Group = form.querySelector('[data-mt-color2-group]');
    var color2Btns = color2Group ? color2Group.querySelectorAll('[data-mt-color2-val]') : [];
    var colorsWrap = form.querySelector('[data-mt-colors]');
    var color1Group = form.querySelector('[data-mt-color-option]');
    var color1Label = color1Group ? color1Group.querySelector('.mt-pdp__opt-label') : null;
    var color1LabelText = color1Label ? color1Label.textContent : 'Color';
    var priceNow = document.querySelector('[data-mt-price-now]');
    var priceOld = document.querySelector('[data-mt-price-old]');
    var priceBadge = document.querySelector('.mt-pdp__price-badge');
    var currentQty = 1;

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function selectedVariant() {
      if (!variants) return null;
      var id = idInput ? parseInt(idInput.value, 10) : null;
      var found = variants.find(function (v) { return v.id === id; });
      return found || variants[0];
    }
    function updatePrice() {
      var ap = wrap.querySelector('[data-mt-pack].mt-active');
      var v = selectedVariant();
      if (!ap || !priceNow || !v) return;
      var qty = parseInt(ap.getAttribute('data-mt-qty'), 10) || 1;
      var disc = parseFloat(ap.getAttribute('data-mt-pack-discount')) || 0;
      var nowC, oldC = null, badgePct = null;
      if (disc > 0) {
        var totalC = v.price * qty;               // precio unidad x cantidad
        nowC = Math.round(totalC * (1 - disc / 100)); // ambas unidades con el descuento aplicado
        oldC = totalC;
        badgePct = disc;
      } else {
        nowC = v.price * qty;
        if (v.compare_at_price && v.compare_at_price > v.price) {
          oldC = v.compare_at_price * qty;
          badgePct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        }
      }
      priceNow.textContent = money(nowC);
      if (priceOld) {
        if (oldC) { priceOld.textContent = money(oldC); priceOld.style.display = ''; }
        else { priceOld.style.display = 'none'; }
      }
      if (priceBadge) {
        if (badgePct) { priceBadge.textContent = '-' + badgePct + '%'; priceBadge.style.display = ''; }
        else { priceBadge.style.display = 'none'; }
      }
    }

    var variants = null;
    var dataEl = document.getElementById('mt-variant-data');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }
    function findByColor(color) {
      if (!variants) return null;
      return variants.find(function (v) { return v.options.indexOf(color) > -1; });
    }

    function setPack(qty) {
      currentQty = qty;
      if (qtyInput) qtyInput.value = qty;
      var two = qty >= 2;
      if (color2Group) color2Group.style.display = two ? '' : 'none';
      if (colorsWrap) colorsWrap.classList.toggle('mt-two', two);
      if (color1Label) color1Label.textContent = two ? 'Color de la 1ª unidad' : color1LabelText;
      updatePrice();
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.classList.remove('mt-active'); });
        p.classList.add('mt-active');
        setPack(parseInt(p.getAttribute('data-mt-qty'), 10) || 1);
      });
    });

    color2Btns.forEach(function (b) {
      b.addEventListener('click', function () {
        color2Btns.forEach(function (x) { x.classList.remove('mt-active'); });
        b.classList.add('mt-active');
      });
    });

    var activePack = wrap.querySelector('[data-mt-pack].mt-active');
    setPack(activePack ? (parseInt(activePack.getAttribute('data-mt-qty'), 10) || 1) : 1);

    /* Con pack de 2: añadir las 2 unidades con sus colores vía carrito AJAX */
    form.addEventListener('submit', function (e) {
      if (currentQty < 2 || !variants || !color2Group) return;
      var id1 = idInput ? parseInt(idInput.value, 10) : null;
      var c2 = color2Group.querySelector('[data-mt-color2-val].mt-active');
      var v2 = c2 ? findByColor(c2.getAttribute('data-value')) : null;
      if (!id1 || !v2) return;
      e.preventDefault();
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [ { id: id1, quantity: 1 }, { id: v2.id, quantity: 1 } ] })
      }).then(function () { window.location.href = '/cart'; })
        .catch(function () { if (addBtn) addBtn.disabled = false; form.submit(); });
    });
  }

  /* ---------- Vídeo demostrativo: clic para reproducir ---------- */
  function initDemoVideo() {
    var frames = document.querySelectorAll('[data-mt-demo]');
    if (!frames.length) return;
    frames.forEach(function (frame) {
      var video = frame.querySelector('video');
      if (!video) return;
      var started = false;
      function play() {
        if (started) return;
        started = true;
        frame.classList.add('mt-playing');
        video.setAttribute('controls', 'controls');
        video.play().catch(function () {});
      }
      frame.addEventListener('click', function (e) {
        if (frame.classList.contains('mt-playing')) return;
        e.preventDefault();
        play();
      });
    });
  }

  /* ---------- Vídeos autoplay: reproducir al ver, pausar al salir ---------- */
  function initAutoVideos() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Order bump del carrito ---------- */
  function initCartBump() {
    var btns = document.querySelectorAll('[data-mt-bump-add]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-mt-bump]');
        var vid = wrap ? wrap.getAttribute('data-mt-bump-variant') : null;
        if (!vid) return;
        btn.disabled = true;
        var t = btn.querySelector('.mt-cbump__btn-txt');
        if (t) t.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        }).then(function () { window.location.reload(); })
          .catch(function () { btn.disabled = false; if (t) t.textContent = '+ Añadir'; });
      });
    });
  }

  function init() {
    initReveal();
    initHeroParallax();
    initFaq();
    initGallery();
    initVariants();
    initPacks();
    initDemoVideo();
    initAutoVideos();
    initCartBump();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
